import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Separator, Text, Row, Button } from '@cuemath/comps';

import { closeModal } from 'actions/modal';
import { Form, Header, Checkbox, Card } from 'semantic-ui-react';
import COLORS from 'constants/colors';
import { Close } from 'styled-icons/material/Close';
import { Warning } from 'styled-icons/material/Warning';
import { store } from 'redux-rest-reducer';
import { withRouter } from 'react-router-dom';

import {
  post as postSubmitData,
  patch as patchEditData,
  get as getEditSheet,
} from 'actions/activities-add-card';

import { HeaderHead, Message, renderFormField } from 'modules/form';

import {
  FIELD_TYPES,
  addCardFields,
  getInputChangeMethod,
  getOnChangeMethod,
} from 'constants/form';

const ButtonWrapper = styled.div`
  opacity: ${({ close }) => (close ? `0.1` : `1`)};
  pointer-events: ${({ close }) => (close ? `none` : `all`)};
`;
const InstructionButtonWrapper = styled.div`
  display: flex;
  margin: 20px;
`;

const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: ${({ close }) => (close ? `0.1` : `1`)};
  pointer-events: ${({ close }) => (close ? `none` : `all`)};
`;

const HeaderHeadWrapper = styled(HeaderHead)`
  padding: 0px 10px 10px 10px;
  margin-top: 10px;
  bottom: 7px;
  position: relative;
`;

const FieldWrapper = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  opacity: ${({ close }) => (close ? `0.1` : `1`)};
  pointer-events: ${({ close }) => (close ? `none` : `all`)};
`;

const FormField = styled(Form.Field)`
  padding-left: 14px;
`;

const ButtonStyle = styled.span`
  margin-left: 20px;
`;

const CloseIcon = styled(Close)`
  position: absolute;
  top: 10px;
  z-index: 2;
  right: 15px;
  width: 20px;
  height: 20px;
  float: right;
  cursor: pointer;
`;

const WarningIcon = styled(Warning)`
  position: absolute;
  top: 40px;
  width: 40px;
  height: 40px;
  transform: translateY(-50%);
  margin: 0 auto;
  color: ${COLORS.COLA};
`;

const AlertCard = styled(Card)`
  position: absolute;
  height: 230px;
  min-width: 400px;
  margin: 0 auto;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 16px;
  z-index: 9999;
  opacity: 1;
  margin-bottom: 20px;
  pointer-events: all;
`;

const AlertModalRow = styled(Row)`
  padding: 20px;
  width: 400px;
`;

const AssignStyle = styled(Text)`
  width: 400px;
`;

const ButtonNo = styled.div`
  position: relative;
  background: #ffffff;
  border: 1.76087px solid #e2e4eb;
  box-sizing: border-box;
  border-radius: 24.6522px;
  width: 135px;
  height: 32px;
  cursor: pointer;
  margin-left: 10px;
`;

const ButtonYes = styled.div`
  position: relative;
  background: ${COLORS.CERULEAN};
  border-radius: 28px;
  width: 135px;
  height: 32px;
  cursor: pointer;
`;

const AlertStyle = styled(Row)`
  width: 240px;
  margin: 0 auto;
`;

const ExitText = styled(Text)`
  padding: 10px;
  margin-top: 60px;
`;

const NoText = styled.div`
  position: relative;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${({ color }) => color};
  display: flex;
  justify-content: center;
  top: 5px;
`;

const CenterAlignedDiv = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LOCATION_FILTER = {
  CW: 'INCLASS',
  HW: 'ATHOME',
  ANY: 'ANY',
};
const SELECTED_LOCATION = {
  INCLASS: 'CW',
  ATHOME: 'HW',
  ANY: 'ANY',
};

const FILTER = {
  TILES: 'activity_tiles',
  TOPICS: 'activity_topics',
  TYPES: 'activity_types',
  GRADES: 'grades',
};

const INSTRUCTIONS_TEXT = {
  ADD_INSTRUCTIONS: 'Add Teacher Instructions',
  EDIT_INSTRUCTIONS: 'Edit Teacher Instructions',
};

const ACTIVITY_ACTION_TEXT = {
  ADD_ACTIVITY: 'Add New Activity',
  EDIT_ACTIVITY: 'Edit Activity',
  COPY_ACTIVITY: 'Copy Activity',
};

const getFormDefaults = editSheetData => {
  const formDefaults = {};

  addCardFields.forEach(field => {
    if (
      !!editSheetData &&
      (editSheetData[field.param] || editSheetData.worksheet[field.param])
    ) {
      if (field.name === FILTER.GRADES) {
        let gradeArr = [];
        editSheetData[field.param].forEach(rec => gradeArr.push(rec.id));
        formDefaults[field.name] = gradeArr;
      }

      if (field.name === FILTER.TOPICS) {
        let topicsArr = [];
        editSheetData[field.param].forEach(rec => topicsArr.push(rec.id));
        formDefaults[field.name] = topicsArr;
      }

      if (field.name === FILTER.TILES) {
        let tilesArr = [];
        editSheetData[field.param].forEach(rec => tilesArr.push(rec.id));
        formDefaults[field.name] = tilesArr;
      }

      if (field.name === FILTER.TYPES) {
        let typesArr = [];
        editSheetData[field.param].forEach(rec => typesArr.push(rec.id));
        formDefaults[field.name] = typesArr;
      }

      if (
        field.name !== FILTER.GRADES &&
        field.name !== FILTER.TILES &&
        field.name !== FILTER.TOPICS &&
        field.name !== FILTER.TYPES
      ) {
        formDefaults[field.name] =
          !!editSheetData && editSheetData.worksheet[field.param]
            ? editSheetData.worksheet[field.param]
            : field.default;
      }
    } else {
      formDefaults[field.name] = field.default;
    }
  });

  return formDefaults;
};
class AddSheet extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      form: getFormDefaults(),
      formFields: this.getFormFields(),
      addData: null,
      showConfirmation: false,
      submitDone: false,
      closeModal: false,
      isValid: true,
      errorText: null,
      message: null,
      editSheetPatch: store.patch(),
      dropdownData: {},
      toggleData: {},
      addSheetPost: store.post(),
      location: null,
      showAddInstructions: false,
      worksheetId: '',
    };

    addCardFields.forEach(field => {
      const methodName = getOnChangeMethod(field.name);
      this[methodName] = this.onChange.bind(this, field.name);
    });
  }

  static propTypes = {
    actions: PropTypes.shape({
      postSubmitData: PropTypes.func.isRequired,
      closeModal: PropTypes.func.isRequired,
    }).isRequired,
    programs: PropTypes.array.isRequired,
  };
  static getDerivedStateFromProps(props, state) {
    const { activityAddCard, nodeId, isEditActivity, getFilteredPrograms } = props;
    const { addSheetPost, editSheetPatch, editSheetData, message } = state;
    const { is_available: isAvailable } = isEditActivity || {};

    const postAddSheet = store.post(activityAddCard, addSheetPost.id);
    const patchEditSheet = store.patch(activityAddCard, editSheetPatch.id);
    const getEditSheet = store.get(activityAddCard, nodeId);

    const newState = {};

    if (getEditSheet && getEditSheet.isLoaded && !editSheetData) {
      newState.editSheetData = getEditSheet.data;
      const {
        attempt_location: attemptLocation,
        is_timed: isTimed,
        sheet_time: sheetTime,
        complete_criteria: completionCriteria,
        reattempt_criteria: reattemptCriteria,
        complete_in: completeIn,
        reattempt_in: reattemptIn,
      } = getEditSheet.data || {};
      const { operator, right } = completionCriteria || {};
      const { operator: reattemptOperator, right: reattemptRight } =
        reattemptCriteria || {};
      newState.location = SELECTED_LOCATION[attemptLocation];
      newState.toggleData = { timed: isTimed, is_available: isAvailable };

      newState.dropdownData = {
        reattempt_criteria: reattemptOperator,
        completion_criteria: operator,
      };
      newState.addData = {
        time: !isTimed ? '' : sheetTime && sheetTime / 60,
        complete_in: completeIn,
        completion_criteria_text: right && right.value,
        reattempt_criteria_text: reattemptRight && reattemptRight.value,
        reattempt_in: reattemptIn,
      };
      newState.form = getFormDefaults(getEditSheet.data);
    }

    if (postAddSheet.resolved) {
      if (postAddSheet.resolved.isCreated && !message) {
        newState.submitDone = true;
        newState.errorText = '';
        newState.message = 'Activity added.';
        getFilteredPrograms();
      } else if (postAddSheet.resolved.isCreatingFailed) {
        newState.submitDone = false;
        newState.message = '';
        newState.errorText = 'Error encountered! Please verify the inputs provided.';
      }
    }

    if (patchEditSheet.resolved) {
      if (patchEditSheet.resolved.isPatched && !message) {
        newState.submitDone = true;
        newState.errorText = '';
        newState.message = 'Activity updated.';
        getFilteredPrograms();
      } else if (patchEditSheet.resolved.isPatchingFailed) {
        newState.submitDone = false;
        newState.message = '';
        newState.errorText = 'Error encountered! Please verify the inputs provided.';
      }
    }

    return newState;
  }

  componentDidMount() {
    const { actions, nodeId } = this.props;
    const { editSheetData } = this.state;

    if (nodeId) {
      actions.getEditSheet(nodeId);
    }

    if (editSheetData) {
      this.setState(() => ({
        form: getFormDefaults(editSheetData),
      }));
    }
  }

  disableAddActivity = () => {
    const { form } = this.state;

    const {
      grades,
      name,
      activity_topics: activityTopics,
      activity_types: activityTypes,
      activity_tiles: activityTiles,
    } = form || {};

    if (
      !(grades && name && activityTopics && activityTypes && activityTiles) ||
      (activityTopics && Array.isArray(activityTopics) && !activityTopics.length) ||
      (grades && Array.isArray(grades) && !grades.length) ||
      (activityTiles && Array.isArray(activityTiles) && !activityTiles.length) ||
      (activityTypes && Array.isArray(activityTypes) && !activityTypes.length) ||
      !name
    ) {
      return true;
    }

    return false;
  };

  onCloseClicked = () => {
    const { closeModal, form } = this.state;
    const { actions } = this.props;

    const changedObj = form;

    const containsDefault =
      changedObj &&
      Object.values(changedObj).length > 0 &&
      Object.values(changedObj).includes('');

    const changesDone =
      changedObj && Object.keys(changedObj).length > 0 && !containsDefault;

    if (changesDone) {
      this.setState({ closeModal: !closeModal });
    } else {
      actions.closeModal();
    }
  };

  onCloseModal = () => {
    const { actions } = this.props;
    actions.closeModal();
  };

  getCheckOptions = (options, isIdTrue) => {
    let arr = [];

    if (isIdTrue) {
      arr = options.map(opt => {
        return { label: opt.name, value: opt.id };
      });
    } else {
      arr = options.map(opt => {
        return { label: opt.name, value: opt.code };
      });
    }

    return arr;
  };

  getFormFields = () => {
    const { programs } = this.props;

    return addCardFields.map(field => {
      if (programs[field.name]) {
        if (field.fieldType === FIELD_TYPES.SELECT) {
          if (field.name === FILTER.GRADES) {
            programs[field.name].sort((a, b) =>
              parseInt(a.name, 10) > parseInt(b.name, 10) ? 1 : -1,
            );
          }
          field.choices = this.getCheckOptions(
            programs[field.name],
            !!programs[field.name][0].id,
          );
        }
      }

      return field;
    });
  };

  onChange = (key, value) => {
    const { form } = this.state;
    const newForm = { ...form };
    newForm[key] = value;
    const stateChanges = { form: newForm };
    this.setState(() => ({ ...stateChanges }));
  };

  onOptionChange = (key, value) => {
    const { form, errorText } = this.state;

    const newForm = { ...form };

    newForm[key] = value;

    const stateChanges = { form: newForm };
    if (errorText) stateChanges.errorText = null;
    this.setState(() => ({ ...stateChanges }));
  };

  onAddSheetClicked = () => {
    const { showConfirmation } = this.state;

    this.setState({ showConfirmation: !showConfirmation });
  };

  renderFormFields = () => {
    const { formFields, form, submitDone, closeModal } = this.state;

    return (
      <FieldWrapper close={closeModal}>
        {formFields &&
          formFields.length &&
          formFields.map((field, index) => {
            field.profileView = true;
            const disabled = submitDone ? submitDone : field.disabled;
            const required = field.required;
            const placeholder = disabled ? '' : field.label;

            return (
              <div key={`${field.name}-${index}`}>
                {renderFormField({
                  ...field,
                  profileForm: true,
                  value: form[field.name],
                  onChange: this[getInputChangeMethod(field)],
                  required,
                  disabled,
                  placeholder,
                  maxlength: field.maxlength,
                })}
              </div>
            );
          })}
      </FieldWrapper>
    );
  };

  getHeading = () => {
    const { action } = this.props;
    switch (action) {
      case 'CREATE':
        return ACTIVITY_ACTION_TEXT.ADD_ACTIVITY;
      case 'EDIT':
        return ACTIVITY_ACTION_TEXT.EDIT_ACTIVITY;
      case 'COPY':
        return ACTIVITY_ACTION_TEXT.COPY_ACTIVITY;
      default:
        return ACTIVITY_ACTION_TEXT.ADD_ACTIVITY;
    }
  };

  getSubmitButtonText = () => {
    const { action } = this.props;
    switch (action) {
      case 'CREATE':
        return ACTIVITY_ACTION_TEXT.ADD_ACTIVITY;
      case 'EDIT':
        return ACTIVITY_ACTION_TEXT.EDIT_ACTIVITY;
      case 'COPY':
        return ACTIVITY_ACTION_TEXT.COPY_ACTIVITY;
      default:
        return ACTIVITY_ACTION_TEXT.ADD_ACTIVITY;
    }
  };

  renderFormHeader = () => {
    const { closeModal } = this.state;

    return (
      <HeaderHeadWrapper close={closeModal}>
        <Header as="h3" floated="left">
          <CloseIcon onClick={this.onCloseClicked} />
          <Separator height={10} transparent />
          <Text weight="bold" color="rgba(0,0,0,.87)">
            {this.getHeading()}
          </Text>
        </Header>
      </HeaderHeadWrapper>
    );
  };

  onModalClose = () => {
    const { message } = this.state;
    return (
      <AlertModalRow>
        <AlertCard>
          <AlertStyle justifyContent="center">
            {!message && (
              <CenterAlignedDiv>
                <WarningIcon />
                <Separator height={15} transparent />
                <ExitText align="center">All unsaved changes will be lost.</ExitText>{' '}
              </CenterAlignedDiv>
            )}
            <Text align="center">Are you sure you want to close this window?</Text>
          </AlertStyle>
          <Separator height={15} transparent />
          <Row justifyContent="center">
            <ButtonYes onClick={() => this.onCloseModal()}>
              <NoText color={COLORS.WHITE}>Close</NoText>{' '}
            </ButtonYes>
            <ButtonNo onClick={() => this.onCloseClicked()}>
              <NoText color="#01A5F2">Cancel</NoText>
            </ButtonNo>
          </Row>
          <Separator height={20} transparent />
        </AlertCard>
        <Separator height={20} transparent />
      </AlertModalRow>
    );
  };

  handleChangeCheckbox = (e, { checked, name }) => {
    let tempData = Object.assign({}, this.state.toggleData);
    tempData[name] = checked;

    this.setState({
      toggleData: tempData,
    });
  };

  renderFormFooter = () => {
    const { submitDone, toggleData, closeModal } = this.state;
    const { is_available: live } = toggleData || {};

    return (
      <FieldWrapper key="sheets" close={closeModal}>
        <Form onChange={this.handleChange}>
          <Separator height={20} transparent />
          <Separator height={20} transparent />
          <Row justifyContent="space-between">
            <FormField label="Live" control="checkbox">
              <Checkbox
                name="is_available"
                toggle
                label=""
                onChange={this.handleChangeCheckbox}
                disabled={submitDone}
                checked={live}
              />
            </FormField>
          </Row>
          <Separator height={40} transparent />
        </Form>
      </FieldWrapper>
    );
  };

  handleRadioButtonChange = e => {
    this.setState({ location: e });
  };

  checkIfOptionsChanged = (oldOptions, newOptions) => {
    let isSame;

    if (oldOptions && newOptions) {
      isSame =
        oldOptions &&
        newOptions &&
        oldOptions.length === newOptions.length &&
        oldOptions.every((element, index) => {
          return element.id === newOptions[index];
        });
    } else if (!oldOptions && newOptions && newOptions.length) {
      isSame = false;
    }

    return isSame;
  };

  getUpdatedFields = () => {
    const { isEditSheet } = this.props;
    const {
      form,
      location,
      toggleData,
      dropdownData,
      addData,
      editSheetData,
    } = this.state;
    const { node_type: prevNodeType, is_available: prevLive } = isEditSheet || {};
    const {
      is_timed: prevIsTimed,
      attempt_location: prevAttemptLocation,
      complete_criteria: prevCompleteCriteria,
      reattempt_criteria: prevReattempt,
      activity_tiles: prevTiles,
      activity_types: prevTypes,
      grades: prevGrades,
      activity_topics: prevTopics,
      worksheet,
      complete_in: prevCompleteIn,
      reattempt_in: prevReattemptIn,
      sheet_time: prevSheetTime,
    } = editSheetData || {};
    const {
      name: prevName,

      learnosity_activity_ref: prevReference,
    } = worksheet || {};

    const {
      node_types: nodeType,
      activity_tiles,
      activity_types,
      grades,
      name,
      reference,
      activity_topics,
    } = form || {};
    const { timed, is_available: live } = toggleData || {};
    const {
      completion_criteria_text: completionText,
      reattempt_criteria_text: reattemptText,
      complete_in: completedIn,
      reattempt_in: reattemptIn,
      time,
    } = addData || {};
    const {
      reattempt_criteria: reattemptSign = '<',
      completion_criteria: completionSign = '>=',
    } = dropdownData || {};

    let patchObj = {};

    const isTopicSame = this.checkIfOptionsChanged(prevTopics, activity_topics);
    const isGradeSame = this.checkIfOptionsChanged(prevGrades, grades);
    const isTileSame = this.checkIfOptionsChanged(prevTiles, activity_tiles);
    const isTypeSame = this.checkIfOptionsChanged(prevTypes, activity_types);

    if (
      (nodeType && !prevNodeType) ||
      (nodeType && prevNodeType && nodeType.toLowerCase() !== prevNodeType.toLowerCase())
    )
      patchObj.node_type = nodeType;
    if (location && location !== SELECTED_LOCATION[prevAttemptLocation])
      patchObj.attempt_location = LOCATION_FILTER[location];
    if (timed !== prevIsTimed) patchObj.is_timed = timed;
    if (
      (completionText && !prevCompleteCriteria) ||
      (completionText &&
        prevCompleteCriteria &&
        ((prevCompleteCriteria.right &&
          prevCompleteCriteria.right.value !== completionText) ||
          prevCompleteCriteria.operator !== completionSign))
    ) {
      if (patchObj.complete_criteria) {
        patchObj.complete_criteria.value = completionText;
        patchObj.complete_criteria.operator = completionSign;
      } else {
        patchObj.complete_criteria = {};
        patchObj.complete_criteria.value = completionText;
        patchObj.complete_criteria.operator = completionSign;
      }
    }

    if (
      (reattemptText && !prevReattempt) ||
      (reattemptText &&
        prevReattempt &&
        ((prevReattempt.right && prevReattempt.right.value !== reattemptText) ||
          prevReattempt.operator !== reattemptSign) &&
        reattemptSign)
    ) {
      if (patchObj.reattempt_criteria) {
        patchObj.reattempt_criteria.operator = reattemptSign;
        patchObj.reattempt_criteria.value = reattemptText;
      } else {
        patchObj.reattempt_criteria = {};
        patchObj.reattempt_criteria.operator = reattemptSign;
        patchObj.reattempt_criteria.value = reattemptText;
      }
    }
    if (name && name !== prevName) patchObj.name = name;

    if (reference && reference !== prevReference)
      patchObj.learnosity_activity_ref = reference;
    if (live !== prevLive) patchObj.is_available = live;
    if (completedIn && completedIn !== prevCompleteIn) patchObj.complete_in = completedIn;
    if (reattemptIn && reattemptIn !== prevReattemptIn)
      patchObj.reattempt_in = reattemptIn;
    if (time !== prevSheetTime) {
      patchObj.sheet_time = time * 60;
    }
    if (!isTopicSame && typeof isTopicSame !== 'undefined')
      patchObj.activity_topic_ids = activity_topics;
    if (!isGradeSame && typeof isGradeSame !== 'undefined') patchObj.grade_ids = grades;
    if (!isTileSame && typeof isTileSame !== 'undefined')
      patchObj.activity_tile_ids = activity_tiles;
    if (!isTypeSame && typeof isTypeSame !== 'undefined')
      patchObj.activity_type_ids = activity_types;

    return patchObj;
  };

  onConfirm = async () => {
    const {
      actions,
      nodeId,
      worksheetId,
      blobs,
      handleActivityDataUpload,
      bucketName,
      isActivityPatch,
      editedRef,
    } = this.props;
    const {
      form,
      toggleData,
      editSheetPatch: { id: patchId },
      addSheetPost: { id },
    } = this.state;

    const {
      activity_tiles: activityTiles,
      grades,
      name,
      activity_topics: activityTopics,
      activity_types: activityTypes,
    } = form || {};

    const { is_available: live } = toggleData || {};

    const url = `https://${bucketName}.s3.amazonaws.com/`;
    const key = `media/wb-activity/${worksheetId}/activity_json`;
    const source = `${url}${key}`;

    if (handleActivityDataUpload) {
      await handleActivityDataUpload(blobs, worksheetId);
    }

    const postObj = {
      node_type: 'WB_ACTIVITY',
      name: name,
      learnosity_activity_ref: source,
      is_available: !live ? false : true,
      is_live: !live ? false : true,
      grade_ids: grades,
      activity_type_ids: activityTypes,
      activity_topic_ids: activityTopics,
      activity_tile_ids: activityTiles,
      worksheet_type: 'WB_ACTIVITY',
      cue_worksheet_id: worksheetId,
    };

    if (nodeId && isActivityPatch) {
      const patchData = this.getUpdatedFields();
      const patchObj = {
        action: 'UPDATE',
        action_data: {
          ...patchData,
          learnosity_activity_ref: editedRef,
          is_live: patchData.is_available,
        },
      };

      actions.patchEditData(patchId, nodeId, patchObj);
    } else {
      actions.postSubmitData(id, postObj);
    }
    this.setState({
      showAddInstructions: true,
      worksheetId,
    });
  };

  getInstructionsLabel = () => {
    const { action } = this.props;
    switch (action) {
      case 'CREATE':
        return INSTRUCTIONS_TEXT.ADD_INSTRUCTIONS;
      case 'EDIT':
      case 'COPY':
        return INSTRUCTIONS_TEXT.EDIT_INSTRUCTIONS;
      default:
        return INSTRUCTIONS_TEXT.ADD_INSTRUCTIONS;
    }
  };

  render() {
    const {
      errorText,
      message,
      showConfirmation,
      closeModal,
      showAddInstructions,
      worksheetId,
    } = this.state;

    let redirectURL;

    const isButtonDisabled = this.disableAddActivity();
    if (
      process.env.REACT_APP_ENV === 'staging' ||
      process.env.NODE_ENV === 'development'
    ) {
      redirectURL = `https://mann-admin.leaptest.cuemath.com/concepts/admin/cueworksheet/edit/?id=${worksheetId}`;
    } else {
      redirectURL = `https://admin.cuemath.com/concepts/admin/cueworksheet/edit/?id=${worksheetId}`;
    }

    return (
      <FormWrapper>
        {this.renderFormHeader()}
        {closeModal && this.onModalClose()}
        <Separator transparent height="25" />
        {this.renderFormFields()}
        <Separator transparent height="25" />
        {this.renderFormFooter()}

        {errorText && <Message error={true}>{errorText}</Message>}
        {message && <Message>{message}</Message>}
        {!showConfirmation && (
          <ButtonWrapper close={closeModal}>
            <div>
              <Separator height="20" transparent />
              <Button
                label={this.getSubmitButtonText()}
                disabled={isButtonDisabled || message}
                onClick={this.onAddSheetClicked}
              />
            </div>
          </ButtonWrapper>
        )}

        {!message && showConfirmation && (
          <ButtonWrapper close={closeModal}>
            <AssignStyle align="center">
              This will create a new version of this activity. Do you want to proceed?
            </AssignStyle>
            <Separator height="20" transparent />
            <Row justifyContent="center">
              <Button label="Confirm" disabled={message} onClick={this.onConfirm} />
              <ButtonStyle>
                <Button
                  label="Cancel"
                  disabled={message}
                  onClick={this.onAddSheetClicked}
                />
              </ButtonStyle>
            </Row>
          </ButtonWrapper>
        )}

        {(showAddInstructions && (
          <InstructionButtonWrapper>
            <a target="_blank" href={redirectURL}>
              <Button label={this.getInstructionsLabel()} />
            </a>
          </InstructionButtonWrapper>
        )) ||
          null}

        <Separator height={40} transparent />
      </FormWrapper>
    );
  }
}

export default withRouter(
  connect(
    ({ activityAddCard, nodeId }) => ({
      activityAddCard,
      editSheet: store.get(activityAddCard, nodeId),
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          closeModal,
          postSubmitData,
          patchEditData,
          getEditSheet,
        },
        dispatch,
      ),
    }),
  )(AddSheet),
);
